import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function Notebook() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Project
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Notebook
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Notebook
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Notebook-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Overview
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Notebook-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Plasmid backbone transformation and isolation
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Notebook-3")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Cloning and transformation
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Notebook-4")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Protein expression
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Notebook-5")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Guanine assay
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Notebook-6")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    LB media preparation
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Notebook-7")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Sonication of samples
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Notebook-8")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    SDS-PAGE
                                </div>
                            </li>

                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Notebook-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Overview
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                Detailed information about our experiment can be found in the notebooks.
                                Below you can read more about plasmid backbone transformation and isolation,
                                cloning and transformation, protein expression and the guanine assay.
                            </div>
                            <div className="mt-5">
                                For those who are interested, we also have detailed information about LB media
                                preparation, sonication of samples, and SDS-PAGE.
                            </div>
                        </div>
                    </div>
                    <div id="Notebook-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10 mb-6">
                        Plasmid backbone transformation and isolation
                    </div>
                    <div className="w-full h-screen">
                        <object
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            data="https://static.igem.wiki/teams/5122/pdf/plasmid-backbone-transformation-isolation.pdf"
                        >
                            <p>Your web browser doesn't have a PDF plugin.</p>
                        </object>
                    </div>
                    <div id="Notebook-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10 mb-6">
                        Cloning and transformation
                    </div>
                    <div className="w-full h-screen mt-6">
                        <object
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            data="https://static.igem.wiki/teams/5122/pdf/cloning-and-transformation.pdf"
                        >
                            <p>Your web browser doesn't have a PDF plugin.</p>
                        </object>
                    </div>
                    <div id="Notebook-4" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10 mb-6">
                        Protein expression
                    </div>
                    <div className="w-full h-screen mt-6">
                        <object
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            data="https://static.igem.wiki/teams/5122/pdf/protein-expression.pdf"
                        >
                            <p>Your web browser doesn't have a PDF plugin.</p>
                        </object>
                    </div>
                    <div id="Notebook-5" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10 mb-6">
                        Guanine assay
                    </div>
                    <div className="w-full h-screen mt-6">
                        <object
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            data="https://static.igem.wiki/teams/5122/pdf/guanine-assay.pdf"
                        >
                            <p>Your web browser doesn't have a PDF plugin.</p>
                        </object>
                    </div>
                    <div id="Notebook-6" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10 mb-6">
                        LB media preparation
                    </div>
                    <div className="w-full h-screen mt-6">
                        <object
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            data="https://static.igem.wiki/teams/5122/pdf/lb-media-prep.pdf"
                        >
                            <p>Your web browser doesn't have a PDF plugin.</p>
                        </object>
                    </div>
                    <div id="Notebook-7" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10 mb-6">
                        Sonication of samples
                    </div>
                    <div className="w-full h-screen mt-6">
                        <object
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            data="https://static.igem.wiki/teams/5122/pdf/sonication-of-samples.pdf"
                        >
                            <p>Your web browser doesn't have a PDF plugin.</p>
                        </object>
                    </div>
                    <div id="Notebook-8" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10 mb-6">
                        SDS-PAGE
                    </div>
                    <div className="w-full h-screen">
                        <object
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            data="https://static.igem.wiki/teams/5122/pdf/sds-page.pdf"
                        >
                            <p>Your web browser doesn't have a PDF plugin.</p>
                        </object>
                    </div>

                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}